import MATIC from './matic.png';
import PALM from './palm.png';
import AETH from './arbitrum.png';
import OPTIMISM from './optimism.png';
import ONE from './harmony.png';
import FTM from './fantom.png';
import ETHEREUM from './eth-logo-new.png';
import BNB from './binance.png';
import AVAX from './avalanche.png';
import GOERLI from './goerli-logo-dark.png';
import LINEA_GOERLI from './linea-testnet-logo.png';
import SEPOLIA from './sepolia-logo-dark.png';
import LINEA_MAINNET from './linea-mainnet-logo.png';

export default {
  PALM,
  MATIC,
  OPTIMISM,
  ONE,
  FTM,
  ETHEREUM,
  BNB,
  AETH,
  AVAX,
  GOERLI,
  'LINEA-GOERLI': LINEA_GOERLI,
  SEPOLIA,
  'LINEA-MAINNET': LINEA_MAINNET,
};
